import { QueryClient } from '@tanstack/react-query';

/**
 * Centralised TanStack Query client.
 *
 * Defaults:
 *   - Stale time 30s — most CUBIX results don't change intra-second.
 *   - 1 retry — user gets feedback fast; the gateway already retries idempotent reads.
 *   - No refetch on window focus — financial dashboards shouldn't flicker on tab switch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

/** Query key factories — keep keys consistent across hooks. */
export const queryKeys = {
  alm: {
    all: ['alm'] as const,
    gaps: (tenantId: string, date?: string) =>
      ['alm', 'gaps', tenantId, date] as const,
    liquidity: (tenantId: string, date?: string) =>
      ['alm', 'liquidity', tenantId, date] as const,
  },
  reporting: {
    all: ['reporting'] as const,
    report: (id: string) => ['reporting', 'report', id] as const,
  },
  market: {
    curves: (tenantId: string) => ['market', 'curves', tenantId] as const,
  },
  risk: {
    all: ['risk'] as const,
  },
} as const;
